import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/AuthContext';
import { OpsLayout } from './layout/OpsLayout';
import { TenantDashboard } from './pages/TenantDashboard';
import { TenantDetail } from './pages/TenantDetail';
import { FulfillmentQueue } from './pages/FulfillmentQueue';
import { StackVersions } from './pages/StackVersions';
import { HealthDashboard } from './pages/HealthDashboard';
import { Settings } from './pages/Settings';
import { RoleDeployments } from './pages/RoleDeployments';
import { ProductDeployments } from './pages/ProductDeployments';
import { CustomerDeployments } from './pages/CustomerDeployments';
import { PC3Console } from './pages/PC3Console';
import { AcpPanels } from './pages/AcpPanels';
import { OnboardingPortal } from './pages/OnboardingPortal';
import { OnboardingDashboard } from './pages/OnboardingDashboard';
import { OnboardingDetail } from './pages/OnboardingDetail';
import { LandingPages } from './pages/LandingPages';
import { DemoCatalog } from './pages/DemoCatalog';
import { ZtrustControl } from './pages/ZtrustControl';
import { AeosOps } from './pages/AeosOps';
import { ChatInbox } from './pages/ChatInbox';
import { SignIn } from './pages/SignIn';
import { Box, Spinner } from '@cloudscape-design/components';

function ProtectedOpsRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box textAlign="center" padding="xxl">
        <Spinner size="large" />
        <Box margin={{ top: 's' }}>Loading...</Box>
      </Box>
    );
  }

  if (!user) {
    return <SignIn onSuccess={() => window.location.reload()} />;
  }

  return (
    <OpsLayout>
      <Routes>
        <Route path="/ops/tenants" element={<TenantDashboard />} />
        <Route path="/ops/tenants/:tenantId" element={<TenantDetail />} />
        <Route path="/ops/fulfillment" element={<FulfillmentQueue />} />
        <Route path="/ops/deployments" element={<RoleDeployments />} />
        <Route path="/ops/deployments/:tenantId" element={<RoleDeployments />} />
        <Route path="/ops/onboarding" element={<OnboardingDashboard />} />
        <Route path="/ops/onboarding/:workflowId" element={<OnboardingDetail />} />
        <Route path="/ops/landing-pages" element={<LandingPages />} />
        <Route path="/ops/demos" element={<DemoCatalog />} />
        <Route path="/ops/ztrust" element={<ZtrustControl />} />
        <Route path="/ops/aeos" element={<AeosOps />} />
        <Route path="/ops/chat" element={<ChatInbox />} />
        <Route path="/ops/product-deployments" element={<ProductDeployments />} />
        <Route path="/ops/customer-deployments" element={<CustomerDeployments />} />
        <Route path="/ops/versions" element={<StackVersions />} />
        <Route path="/ops/health" element={<HealthDashboard />} />
        <Route path="/pc3" element={<PC3Console />} />
        <Route path="/acp-panels" element={<AcpPanels />} />
        <Route path="/ops/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/ops/fulfillment" replace />} />
      </Routes>
    </OpsLayout>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/onboard" element={<OnboardingPortal />} />
          <Route path="/*" element={<ProtectedOpsRoutes />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
